import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { FabricanteService } from 'app/services/fabricante.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fabricante-list',
  templateUrl: './fabricante-list.component.html',
  styleUrls: ['./fabricante-list.component.scss']
})
export class FabricanteListComponent implements OnInit {
  
  // Private variables
  private _unsubscribeAll: Subject<any> = new Subject();
  
  // Public variables
  public loading: boolean = false;
  public ColumnMode = ColumnMode;
  public rows: any[] = [];
  public basicSelectedOption: number = 10;
  public contentHeader: any;
  private tempData = [];
  public temp = [];
  public selectedStatus: any;

  @ViewChild(DatatableComponent) table: DatatableComponent;

  constructor(
    private fabricanteService: FabricanteService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.loading = true;
    
    try {
      const result = await this.fabricanteService.get();
      this.rows = Array.isArray(result) ? result : [];
      this.temp = Array.isArray(result) ? [...result] : [];
    } catch (error) {
      console.error('Erro ao carregar fabricantes:', error);
      this.rows = [];
      this.temp = [];
    } finally {
      this.loading = false;
    }

    this.contentHeader = {
      headerTitle: "Fabricantes",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          { name: "Início", isLink: false },
          { name: "Fabricantes", isLink: false }
        ]
      }
    };
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  nomeFilter(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.temp.filter(function (d) {
      if (d.nome != null) {
        return d.nome.toLowerCase().indexOf(val) !== -1 || !val;
      }
    });
    this.rows = temp;
    this.table.offset = 0;
  }

  statusFilter() {
    if (this.selectedStatus == 0) {
      this.rows = this.temp;
      return false;
    }
    const val = this.selectedStatus;
    const temp = this.temp.filter(function (d) {
      return d.flg_status.toString() === val.toString();
    });
    this.rows = temp;
    this.table.offset = 0;
  }

  onEdit(id_fabricante) {
    this.router.navigate(['fabricante/editar/', id_fabricante]);
  }

  async onDelete(id_fabricante: number) {
    const result = await Swal.fire({
      title: 'Tem certeza?',
      text: "Esta ação não poderá ser revertida!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        this.loading = true;
        await this.fabricanteService.delete(id_fabricante);
        
        this.rows = this.rows.filter(row => row.id_fabricante !== id_fabricante);
        this.temp = this.temp.filter(row => row.id_fabricante !== id_fabricante);
        
        Swal.fire(
          'Deletado!',
          'O fabricante foi deletado com sucesso.',
          'success'
        );
      } catch (error) {
        console.error('Erro ao deletar fabricante:', error);
        Swal.fire(
          'Erro!',
          'Ocorreu um erro ao deletar o fabricante.',
          'error'
        );
      } finally {
        this.loading = false;
      }
    }
  }

  public onCreate(): void {
    this.router.navigate(['fabricante/cadastro']);
  }
}
